import Vue from 'vue';
import VueMoment from 'vue-moment';
import { BootstrapVue } from 'bootstrap-vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';

import App from './App';
import store from './store';
import router from './router';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Add a universal label-key directive so you can use it as an attribute
// LabelKey will insert translated text into HTML elements
import LabelKey from '@/directives/label-key';
Vue.directive('label-key', LabelKey);

Vue.config.productionTip = false;
Vue.use(VueMoment);
Vue.use(BootstrapVue);

// Add a universal router-link directive so you can use it as an attribute
Vue.directive('router-link', {
  inserted(el, binding, vnode) {
    el.addEventListener('click', () => {
      vnode.context.$router.push(binding.value);
    });
    el.classList.add('router-link');
  },
});

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');

store.dispatch('translations/fetch');

if (window.location.hostname !== 'localhost') {
  // Don't enable Sentry when testing locally
  console.log(
    'Enable Sentry',
    process.env.VUE_APP_BRANCH,
    process.env.VUE_APP_RELEASE
  );
  const branch = process.env.VUE_APP_BRANCH;
  const release = process.env.VUE_APP_RELEASE;
  const environment = branch;
  Sentry.init({
    dsn:
      'https://f718b30c14be42db9601243177720f37@o371444.ingest.sentry.io/5438958',
    environment,
    release,
    integrations: [
      new Integrations.BrowserTracing(),
      new VueIntegration({
        Vue,
        logErrors: true,
        tracing: true,
      }),
    ],
    tracesSampleRate: 0.1,
  });
}
